<template>
     <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="warningModal"> 
                        <div class="headerContainer"> 
                            <img src="../assets/warning.svg">
                            <div class="heading">You are logged in elsewhere</div>
                        </div>
                        <div class="description">You can only be logged on in one computer at a time.
                            <br>Logging in here will automatically log you out from other devices</div>
                        <div class="btns"> 
                            <div class="cancel" @click="onCloseClick">Cancel</div>
                            <div class="continue" @click="onContinueClick">Continue</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    name: 'LoginWarningModal',
    methods: {
        onCloseClick(){
            this.$emit('cancelClicked')
        },
        onContinueClick(){
            this.$emit('continueClicked')
        }
    }
    
}

</script>

<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    .headerContainer{
        display: flex;
        align-items: center;
    }

    .heading{
        color: #141414;
        font-family: 'Inter-Regular';
        font-size: 24px;
        font-style: normal;
        font-weight: 900;
        line-height: 28px;
        letter-spacing: -0.72px;
        margin-left: 12px;
    }

    .description{
        color:  rgba(0, 0, 0, 0.65);
        font-family: 'Inter-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        letter-spacing: -0.08px;
        margin: 22px auto 36px;
    }

    .btns{
        display: flex;
        justify-content: center;
        color:  #FFF;
        text-align: center;
        font-family: 'Inter-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
    }

    .cancel{
        cursor: pointer;
        border-radius: 4px;
        border: 1px solid  #2E31BE;
        display: flex;
        padding: 13px 24px;
        justify-content: center;
        align-items: center;
        gap: 12px;
        width: 200px;
        color: #2E31BE;
        margin-right: 16px;
    }

    .continue{
        cursor: pointer;
        display: flex;
        padding: 13px 24px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 200px;
        border-radius: 4px;
        background: #2E31BE;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }
    .modal-default-button {
      float: right;
    }
    .modal-enter-from, .modal-leave-to {
        opacity: 0;
    }
    .modal-enter-active .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .warningModal{
        font-family: 'Inter-Regular';
        padding: 60px 32px 32px;
        background: #FFFFFF;
        border-radius: 16px;
        width: 520px;
        margin: auto;
    }

   
</style>
